(function () {
  function parseProductJsonFromPage() {
    var el = document.querySelector('script[type="application/json"][data-tryon-page-product]');
    if (!el || !el.textContent || !String(el.textContent).trim()) {
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("[TryOn] Invalid product JSON in page.", e);
      return null;
    }
  }

  /** Strip HTML from product body; decode entities via DOM. */
  function htmlToPlainText(html) {
    if (html == null || html === "") {
      return "";
    }
    var s = String(html).trim();
    if (!s) {
      return "";
    }
    var tmp = document.createElement("div");
    tmp.innerHTML = s;
    var text = tmp.textContent || tmp.innerText || "";
    return text.replace(/\s+/g, " ").trim();
  }

  /** garment_description: plain-text description, type, tags (no title). */
  function buildGarmentDescriptionKeyValues(p) {
    if (!p || typeof p !== "object") {
      return {
        description: "",
        type: "",
        tags: []
      };
    }
    var descRaw = p.description != null ? p.description : p.body_html;
    var ptype = p.type != null ? p.type : p.product_type;
    var tags = p.tags;
    if (!Array.isArray(tags)) {
      tags = tags != null && String(tags).length ? [String(tags)] : [];
    }
    return {
      description: htmlToPlainText(descRaw),
      type: ptype != null ? String(ptype) : "",
      tags: tags
    };
  }

  function getGarmentDescriptionForApi() {
    var p = parseProductJsonFromPage();
    return buildGarmentDescriptionKeyValues(p);
  }

  /** Browser max JPEG quality for capture, watermark, and exported files. */
  var TRYON_JPEG_QUALITY = 1;
  var TRYON_DAILY_STATE_KEY = "br_tryon_daily_state";
  var TRYON_LEGACY_STORAGE_KEYS = [
    "br_tryon_daily_generation",
    "br_tryon_successful_generation_count"
  ];

  function getLocalDateKey() {
    var d = new Date();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
  }

  function createFreshDailyState() {
    return {
      date: getLocalDateKey(),
      generationCount: 0,
      generationAttempts: 0,
      contactSubmitted: false,
      contact: null
    };
  }

  function clearTryOnDailyStorage() {
    var i;
    try {
      localStorage.removeItem(TRYON_DAILY_STATE_KEY);
      for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
        localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
      }
    } catch (e) {
      /* ignore */
    }
  }

  /** Drop yesterday's (or invalid) data — we only keep one small record for today. */
  function purgeStaleTryOnDailyStorage() {
    var today = getLocalDateKey();
    var i;
    try {
      for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
        localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
      }
      var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
      if (!raw) {
        return;
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.date !== today) {
        clearTryOnDailyStorage();
      }
    } catch (e) {
      clearTryOnDailyStorage();
    }
  }

  function readDailyState() {
    try {
      var today = getLocalDateKey();
      var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
      if (!raw) {
        return createFreshDailyState();
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.date !== today) {
        clearTryOnDailyStorage();
        return createFreshDailyState();
      }
      var genCount = parsed.generationCount;
      if (genCount == null && parsed.count != null) {
        genCount = parseInt(parsed.count, 10);
      } else {
        genCount = parseInt(genCount, 10);
      }
      if (isNaN(genCount) || genCount < 0) {
        genCount = 0;
      }
      var genAttempts = parseInt(parsed.generationAttempts, 10);
      if (isNaN(genAttempts) || genAttempts < 0) {
        genAttempts = genCount > 0 ? genCount : 0;
      }
      var contact = null;
      if (parsed.contact && typeof parsed.contact === "object") {
        contact = {
          name: parsed.contact.name != null ? String(parsed.contact.name) : "",
          countryCode:
            parsed.contact.countryCode != null ? String(parsed.contact.countryCode) : "",
          mobile: parsed.contact.mobile != null ? String(parsed.contact.mobile) : "",
          phone: parsed.contact.phone != null ? String(parsed.contact.phone) : "",
          phoneVerified: parsed.contact.phoneVerified === true
        };
      }
      return {
        date: today,
        generationCount: genCount,
        generationAttempts: genAttempts,
        contactSubmitted: parsed.contactSubmitted === true,
        contact: contact
      };
    } catch (e) {
      clearTryOnDailyStorage();
      return createFreshDailyState();
    }
  }

  function writeDailyState(state) {
    try {
      localStorage.setItem(TRYON_DAILY_STATE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
  }

  function incrementSuccessfulGenerationCount() {
    var state = readDailyState();
    state.generationCount = (state.generationCount || 0) + 1;
    writeDailyState(state);
  }

  function recordGenerationAttempt() {
    var state = readDailyState();
    state.generationAttempts = (state.generationAttempts || 0) + 1;
    writeDailyState(state);
  }

  function persistContactSubmitted(payload) {
    if (!payload) {
      return;
    }
    var state = readDailyState();
    state.contactSubmitted = true;
    state.contact = {
      name: payload.name,
      countryCode: payload.countryCode,
      mobile: payload.mobile,
      phone:
        payload.phone ||
        buildInternationalPhone(payload.countryCode, payload.mobile),
      phoneVerified: payload.phoneVerified === true
    };
    writeDailyState(state);
  }

  var TRYON_PHONE_MIN_LEN = 7;
  var TRYON_PHONE_MAX_LEN = 15;

  function normalizeNationalPhoneDigits(value, maxLen) {
    return String(value || "")
      .replace(/\D/g, "")
      .slice(0, maxLen != null ? maxLen : TRYON_PHONE_MAX_LEN);
  }

  var TRYON_PINNED_COUNTRY_ISOS = ["ca", "us", "ae", "gb"];
  var TRYON_COUNTRY_LABELS = {
    ca: "+1 CA",
    us: "+1 US",
    ae: "+971 UAE",
    gb: "+44 UK"
  };

  function createTryOnPhoneOption(country, defaultIso) {
    var iso2 = String(country.iso2).toLowerCase();
    var option = document.createElement("option");
    option.value = iso2;
    option.setAttribute("data-dial-code", String(country.dialCode).replace(/\D/g, ""));
    option.setAttribute("data-iso", iso2.toUpperCase());
    option.textContent =
      TRYON_COUNTRY_LABELS[iso2] || "+" + country.dialCode + " " + iso2.toUpperCase();
    if (iso2 === defaultIso) {
      option.selected = true;
    }
    return option;
  }

  function populateTryOnPhoneCodeSelect(selectEl) {
    if (!selectEl || !window.intlTelInput || typeof window.intlTelInput.getCountryData !== "function") {
      return false;
    }

    var countries = window.intlTelInput.getCountryData();
    var defaultIso = String(selectEl.getAttribute("data-default-iso") || "CA").toLowerCase();
    var fragment = document.createDocumentFragment();
    var hasDefault = false;
    var usedIsos = {};
    var countryByIso = {};

    countries.forEach(function (country) {
      if (!country || !country.iso2 || !country.dialCode) {
        return;
      }
      countryByIso[String(country.iso2).toLowerCase()] = country;
    });

    TRYON_PINNED_COUNTRY_ISOS.forEach(function (iso2) {
      var country = countryByIso[iso2];
      if (!country) {
        return;
      }
      var option = createTryOnPhoneOption(country, defaultIso);
      if (option.selected) {
        hasDefault = true;
      }
      usedIsos[iso2] = true;
      fragment.appendChild(option);
    });

    var remaining = countries.filter(function (country) {
      if (!country || !country.iso2 || !country.dialCode) {
        return false;
      }
      return !usedIsos[String(country.iso2).toLowerCase()];
    });
    remaining.sort(function (a, b) {
      return String(a.name || a.iso2).localeCompare(String(b.name || b.iso2));
    });

    remaining.forEach(function (country) {
      var option = createTryOnPhoneOption(country, defaultIso);
      if (option.selected) {
        hasDefault = true;
      }
      fragment.appendChild(option);
    });

    selectEl.textContent = "";
    selectEl.appendChild(fragment);
    if (!hasDefault && selectEl.options.length) {
      selectEl.selectedIndex = 0;
    }
    return selectEl.options.length > 0;
  }

  function getTryOnDialCode(selectEl) {
    if (!selectEl) {
      return "";
    }
    var option = selectEl.options[selectEl.selectedIndex];
    if (option) {
      return String(option.getAttribute("data-dial-code") || "").replace(/\D/g, "");
    }
    return String(selectEl.value || "").replace(/\D/g, "");
  }

  function getTryOnCountryIso(selectEl) {
    if (!selectEl) {
      return "";
    }
    var option = selectEl.options[selectEl.selectedIndex];
    if (option) {
      return String(option.value || option.getAttribute("data-iso") || "").toLowerCase();
    }
    return "";
  }

  function buildInternationalPhone(dialCode, nationalDigits) {
    if (!dialCode || !nationalDigits) {
      return "";
    }
    return "+" + dialCode + nationalDigits;
  }

  function isValidInternationalPhone(dialCode, nationalDigits, countryIso) {
    if (!dialCode || !nationalDigits) {
      return false;
    }
    if (
      nationalDigits.length < TRYON_PHONE_MIN_LEN ||
      nationalDigits.length > TRYON_PHONE_MAX_LEN
    ) {
      return false;
    }
    if (
      window.intlTelInput &&
      window.intlTelInput.utils &&
      typeof window.intlTelInput.utils.isValidNumber === "function"
    ) {
      var fullNumber = buildInternationalPhone(dialCode, nationalDigits);
      return window.intlTelInput.utils.isValidNumber(
        fullNumber,
        String(countryIso || "").toLowerCase()
      );
    }
    return true;
  }

  function getTryOnPhoneValidationMessage(nationalDigits) {
    if (
      !nationalDigits ||
      nationalDigits.length < TRYON_PHONE_MIN_LEN ||
      nationalDigits.length > TRYON_PHONE_MAX_LEN
    ) {
      return (
        "Phone number must be between " +
        TRYON_PHONE_MIN_LEN +
        " and " +
        TRYON_PHONE_MAX_LEN +
        " digits."
      );
    }
    return "Please enter a valid mobile number for the selected country code.";
  }

  function resetTryOnPhoneCodeSelect(selectEl) {
    if (!selectEl) {
      return;
    }
    var defaultIso = String(selectEl.getAttribute("data-default-iso") || "CA").toLowerCase();
    var defaultOption = selectEl.querySelector('option[value="' + defaultIso + '"]');
    if (defaultOption) {
      selectEl.value = defaultIso;
      return;
    }
    selectEl.selectedIndex = 0;
  }

  /** Prefer exact API error text for user-facing status messages. */
  function extractTryonApiErrorMessage(payload, bodyText, httpStatus) {
    var fallback =
      httpStatus != null ? "Server request failed (" + httpStatus + ")." : "Try-on failed. Please retry.";

    if (payload && typeof payload === "object") {
      if (typeof payload.error === "string" && payload.error.trim()) {
        return payload.error.trim();
      }
      if (payload.error && typeof payload.error === "object") {
        if (typeof payload.error.message === "string" && payload.error.message.trim()) {
          return payload.error.message.trim();
        }
        if (typeof payload.error.detail === "string" && payload.error.detail.trim()) {
          return payload.error.detail.trim();
        }
      }
      if (typeof payload.message === "string" && payload.message.trim()) {
        return payload.message.trim();
      }
      if (typeof payload.detail === "string" && payload.detail.trim()) {
        return payload.detail.trim();
      }
      if (typeof payload.reason === "string" && payload.reason.trim()) {
        return payload.reason.trim();
      }
      if (Array.isArray(payload.errors) && payload.errors.length) {
        var parts = payload.errors
          .map(function (entry) {
            if (typeof entry === "string") {
              return entry.trim();
            }
            if (entry && typeof entry.message === "string") {
              return entry.message.trim();
            }
            if (entry && typeof entry.msg === "string") {
              return entry.msg.trim();
            }
            return "";
          })
          .filter(Boolean);
        if (parts.length) {
          return parts.join(" ");
        }
      }
    }

    if (bodyText && typeof bodyText === "string") {
      var trimmed = bodyText.trim();
      if (trimmed) {
        try {
          var parsed = JSON.parse(trimmed);
          var fromJson = extractTryonApiErrorMessage(parsed, "", httpStatus);
          if (fromJson && fromJson.indexOf("Server request failed") !== 0) {
            return fromJson;
          }
        } catch (e) {
          if (trimmed.length < 800 && trimmed.indexOf("<") !== 0) {
            return trimmed;
          }
        }
      }
    }

    return fallback;
  }

  purgeStaleTryOnDailyStorage();

  function initTryOn(root) {
    if (!root || root.dataset.tryonReady === "true") {
      return;
    }
    root.dataset.tryonReady = "true";

    var modal = root.parentElement.querySelector("[data-tryon-modal]");
    if (!modal) {
      return;
    }

    var instanceId = root.getAttribute("data-tryon-instance");
    var openButtons;
    if (instanceId) {
      openButtons = document.querySelectorAll(
        '[data-tryon-instance="' + instanceId + '"][data-tryon-open]'
      );
    } else {
      openButtons = root.querySelectorAll("[data-tryon-open]");
    }
    var closeButtons = modal.querySelectorAll("[data-tryon-close]");
    var garmentImage = modal.querySelector("[data-tryon-garment]");
    var video = modal.querySelector("[data-tryon-video]");
    var canvas = modal.querySelector("[data-tryon-canvas]");
    var previewImage = modal.querySelector("[data-tryon-preview-image]");
    var resultImage = modal.querySelector("[data-tryon-result-image]");
    var uploadBox = modal.querySelector("[data-tryon-upload-trigger]");
    var cameraButton = modal.querySelector("[data-tryon-camera]");
    var chooseButton = modal.querySelector("[data-tryon-choose]");
    var fileInput = modal.querySelector("[data-tryon-file]");
    var statusNode = modal.querySelector("[data-tryon-status]");
    var loaderNode = modal.querySelector("[data-tryon-loader]");
    var loaderTextNode = modal.querySelector("[data-tryon-loader-text]");
    var cameraInstructionNode = modal.querySelector("[data-tryon-camera-instruction]");
    var cameraFlipButton = modal.querySelector("[data-tryon-camera-flip]");
    var captureButton = modal.querySelector("[data-tryon-capture]");
    var countdownNode = modal.querySelector("[data-tryon-countdown]");
    var downloadButton = modal.querySelector("[data-tryon-download]");
    var shareButton = modal.querySelector("[data-tryon-share]");
    var whatsappButton = modal.querySelector("[data-tryon-whatsapp]");
    var regenerateButton = modal.querySelector("[data-tryon-regenerate]");
    var detailsModal = modal.querySelector("[data-tryon-details-modal]");
    var detailsTitleEl = modal.querySelector("[data-tryon-details-title]");
    var detailsInnerDialog = modal.querySelector("[data-tryon-details-dialog]");
    var detailsNameInput = modal.querySelector("[data-tryon-customer-name]");
    var detailsPhoneInput = modal.querySelector("[data-tryon-customer-phone]");
    var detailsPhoneCodeSelect = modal.querySelector("[data-tryon-phone-code]");
    var detailsErrorNode = modal.querySelector("[data-tryon-details-error]");
    var detailsConsentInput = modal.querySelector("[data-tryon-consent]");
    var detailsSubmitButton = modal.querySelector("[data-tryon-details-submit]");
    var detailsCancelButton = modal.querySelector("[data-tryon-details-cancel]");
    var detailsStepDetails = modal.querySelector("[data-tryon-details-step-details]");
    var detailsStepOtp = modal.querySelector("[data-tryon-details-step-otp]");
    var otpHintNode = modal.querySelector("[data-tryon-otp-hint]");
    var otpInput = modal.querySelector("[data-tryon-otp-input]");
    var otpResendButton = modal.querySelector("[data-tryon-otp-resend]");
    var otpChangeButton = modal.querySelector("[data-tryon-otp-change]");
    var toolbarBusyEl = modal.querySelector("[data-tryon-toolbar-busy]");
    var toolbarBusyTextEl = modal.querySelector("[data-tryon-toolbar-busy-text]");

    var stream = null;
    var cameraFacingMode = "user";
    var isCameraCaptureInProgress = false;
    var bodySeenStreak = 0;
    var bodyLostStreak = 0;
    var BODY_SEEN_CHECKS = 2;
    var BODY_LOST_CHECKS = 4;
    var captureTimer = null;
    var bodyCheckTimer = null;
    var countdownInterval = null;
    var pose = null;
    var poseReady = false;
    var poseFramePending = false;
    var poseLoopActive = false;
    var latestPoseLandmarks = null;
    var faceDetector = null;
    var faceDetectorReady = false;
    var faceDetectQueue = [];
    var poseMissStreak = 0;
    var lastHumanDetected = false;
    var lastLiveFaceDetected = false;
    var lastLiveFaceDetectedAt = 0;
    var humanCheckInFlight = false;
    var FACE_CHECK_TIMEOUT_MS = 1200;
    var POSE_CHECK_TIMEOUT_MS = 1500;
    var CAPTURE_CONFIRM_TIMEOUT_MS = 500;
    var LIVE_FACE_MAX_AGE_MS = 500;
    var currentState = "empty";
    var isLoading = false;
    var isToolbarActionBusy = false;
    var isDetailsSubmitBusy = false;
    var detailsSubmitLabel = "Send OTP";
    var otpResendCooldownTimer = null;
    var pendingOtpPhone = "";
    var OTP_RESEND_COOLDOWN_MS = 60 * 1000;
    var loadingTextInterval = null;
    var lastSourceBlob = null;
    var generatedBlob = null;
    var generatedFilename = "try-on-result.jpg";
    var loadingMessages = [
      "Analyzing model pose...",
      "Analyzing garment details...",
      "Fitting garment on your photo...",
      "Rendering final try-on image..."
    ];
    var contextMenuBlocker = null;

    if (detailsPhoneCodeSelect) {
      if (!populateTryOnPhoneCodeSelect(detailsPhoneCodeSelect)) {
        console.warn("[TryOn] intl-tel-input country list could not be loaded.");
      }
    }

    if (detailsPhoneInput) {
      detailsPhoneInput.addEventListener("input", function () {
        var digits = normalizeNationalPhoneDigits(
          detailsPhoneInput.value,
          TRYON_PHONE_MAX_LEN
        );
        if (detailsPhoneInput.value !== digits) {
          detailsPhoneInput.value = digits;
        }
        setInputErrorState(detailsPhoneInput, false);
        if (detailsPhoneCodeSelect) {
          setInputErrorState(detailsPhoneCodeSelect, false);
        }
        if (detailsErrorNode && detailsErrorNode.textContent.indexOf("phone number") !== -1) {
          setDetailsError("");
        }
      });
      detailsPhoneInput.addEventListener("paste", function (event) {
        event.preventDefault();
        var pasted = "";
        try {
          pasted = (event.clipboardData || window.clipboardData).getData("text");
        } catch (e) {
          pasted = "";
        }
        detailsPhoneInput.value = normalizeNationalPhoneDigits(
          detailsPhoneInput.value + pasted,
          TRYON_PHONE_MAX_LEN
        );
      });
    }
    if (detailsPhoneCodeSelect) {
      detailsPhoneCodeSelect.addEventListener("change", function () {
        if (!detailsPhoneInput) {
          return;
        }
        detailsPhoneInput.value = normalizeNationalPhoneDigits(
          detailsPhoneInput.value,
          TRYON_PHONE_MAX_LEN
        );
        setInputErrorState(detailsPhoneCodeSelect, false);
        setInputErrorState(detailsPhoneInput, false);
        setDetailsError("");
      });
    }

    if (!openButtons.length || !uploadBox || !fileInput || !video || !canvas || !previewImage || !resultImage) {
      return;
    }

    /* Modal must live under document.body so position:fixed + z-index sit above .header-section (z-index:50).
       Nested inside product markup it can stack under the sticky header due to ancestor stacking contexts. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function setStatus(message, variant) {
      if (!statusNode) {
        return;
      }
      statusNode.textContent = message || "";
      statusNode.classList.toggle("br-tryon-status--error", variant === "error");
    }

    function setCameraInstruction(message) {
      if (!cameraInstructionNode) {
        return;
      }
      cameraInstructionNode.textContent = message;
    }

    function setDetailsError(message) {
      if (detailsErrorNode) {
        detailsErrorNode.textContent = message || "";
      }
    }

    function getDetailsBusyLabel(actionLabel) {
      if (actionLabel === "generate") {
        return "Generating…";
      }
      if (actionLabel === "share") {
        return "Sharing…";
      }
      return "Downloading…";
    }

    function setDetailsSubmitBusy(busy, busyText) {
      isDetailsSubmitBusy = busy;
      if (detailsModal) {
        detailsModal.setAttribute("data-submit-busy", busy ? "true" : "false");
      }
      if (detailsSubmitButton) {
        detailsSubmitButton.disabled = busy;
        detailsSubmitButton.classList.toggle("is-busy", busy);
        detailsSubmitButton.setAttribute("aria-busy", busy ? "true" : "false");
        detailsSubmitButton.textContent = busy ? busyText || "Please wait…" : detailsSubmitLabel;
      }
      if (detailsCancelButton) {
        detailsCancelButton.disabled = busy;
      }
      if (detailsNameInput) {
        detailsNameInput.disabled = busy;
      }
      if (detailsPhoneInput) {
        detailsPhoneInput.disabled = busy;
      }
      if (detailsPhoneCodeSelect) {
        detailsPhoneCodeSelect.disabled = busy;
      }
      if (detailsConsentInput) {
        detailsConsentInput.disabled = busy;
      }
      if (otpInput) {
        otpInput.disabled = busy;
      }
      if (otpResendButton && busy) {
        otpResendButton.disabled = true;
      }
      if (otpChangeButton) {
        otpChangeButton.disabled = busy;
      }
    }

    function setInputErrorState(input, hasError) {
      if (!input) {
        return;
      }
      input.classList.toggle("br-tryon-input-error", !!hasError);
    }

    function setUploadState(state) {
      currentState = state;
      uploadBox.setAttribute("data-state", state);
    }

    function setCountdownValue(value) {
      if (!countdownNode) {
        return;
      }
      if (value) {
        countdownNode.textContent = String(value);
        uploadBox.setAttribute("data-countdown-active", "true");
      } else {
        countdownNode.textContent = "";
        uploadBox.setAttribute("data-countdown-active", "false");
      }
    }

    function setLoading(value, fixedMessage) {
      isLoading = value;
      uploadBox.setAttribute("data-loading", value ? "true" : "false");
      if (loaderNode) {
        loaderNode.setAttribute("aria-hidden", value ? "false" : "true");
      }

      if (loadingTextInterval) {
        clearInterval(loadingTextInterval);
        loadingTextInterval = null;
      }
      if (!loaderTextNode) {
        return;
      }

      if (value) {
        if (fixedMessage) {
          loaderTextNode.textContent = fixedMessage;
        } else {
          var messageIndex = 0;
          loaderTextNode.textContent = loadingMessages[messageIndex];
          loadingTextInterval = setInterval(function () {
            messageIndex = (messageIndex + 1) % loadingMessages.length;
            loaderTextNode.textContent = loadingMessages[messageIndex];
          }, 1400);
        }
      } else {
        loaderTextNode.textContent = loadingMessages[0];
      }
    }

    function setToolbarActionLoading(active, message) {
      isToolbarActionBusy = !!active;
      uploadBox.setAttribute("data-toolbar-busy", active ? "true" : "false");
      if (toolbarBusyEl) {
        if (active) {
          toolbarBusyEl.removeAttribute("hidden");
        } else {
          toolbarBusyEl.setAttribute("hidden", "");
        }
      }
      if (toolbarBusyTextEl) {
        toolbarBusyTextEl.textContent = active && message ? message : "";
      }
    }

    function nextPaint() {
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      });
    }

    /** Live store URL from Liquid (shop.url); used when theme dev serves images on localhost. */
    function getTryonStoreOrigin() {
      var origin = (modal.dataset.tryonStoreOrigin || "").trim().replace(/\/$/, "");
      if (origin) {
        return origin;
      }
      if (window.Shopify && Shopify.shop) {
        return "https://" + String(Shopify.shop).replace(/\/$/, "");
      }
      return "";
    }

    function toApiAccessibleGarmentUrl(url) {
      if (!url || typeof url !== "string") {
        return "";
      }
      var trimmed = url.trim();
      if (!trimmed) {
        return "";
      }
      try {
        var parsed = new URL(trimmed, window.location.href);
        if (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost") {
          var storeOrigin = getTryonStoreOrigin();
          if (storeOrigin) {
            return storeOrigin + parsed.pathname + parsed.search;
          }
        }
        return parsed.href;
      } catch (e) {
        return trimmed;
      }
    }

    function getActiveGarmentUrl() {
      if (modal.dataset.tryonUseTestGarment === "true") {
        return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
      }

      var detailRoot = document.querySelector(".thb-product-detail");
      if (!detailRoot) {
        return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
      }

      function imageUrlFrom(node) {
        if (!node) {
          return "";
        }
        return node.currentSrc || node.src || "";
      }

      function imageFromSlide(slide) {
        if (!slide) {
          return "";
        }
        var imageNode =
          slide.querySelector(".product-single__media-image img") ||
          slide.querySelector("img");
        return imageUrlFrom(imageNode);
      }

      // 1) Flickity active slide.
      var selectedSlide = detailRoot.querySelector(".product-images__slide.is-selected");
      var selectedUrl = imageFromSlide(selectedSlide);
      if (selectedUrl) {
        return toApiAccessibleGarmentUrl(selectedUrl);
      }

      // 2) Theme active slide state.
      var activeSlide = detailRoot.querySelector(".product-images__slide.is-active");
      var activeUrl = imageFromSlide(activeSlide);
      if (activeUrl) {
        return toApiAccessibleGarmentUrl(activeUrl);
      }

      // 3) Active thumbnail mapped to corresponding slide id.
      var activeThumb = detailRoot.querySelector(".product-thumbnail.is-active, .product-thumbnail.is-initial-selected");
      if (activeThumb && activeThumb.id && activeThumb.id.indexOf("Thumb-") === 0) {
        var mappedSlide = detailRoot.querySelector("#" + activeThumb.id.replace("Thumb-", "Slide-"));
        var mappedUrl = imageFromSlide(mappedSlide);
        if (mappedUrl) {
          return toApiAccessibleGarmentUrl(mappedUrl);
        }
      }

      // 4) Final fallback to first gallery image.
      var fallbackImage = detailRoot.querySelector(".product-images img");
      return toApiAccessibleGarmentUrl(
        imageUrlFrom(fallbackImage) || modal.dataset.defaultGarment || ""
      );
    }

    function syncGarmentImage() {
      var garmentUrl = getActiveGarmentUrl();
      if (garmentUrl && garmentImage) {
        garmentImage.src = garmentUrl;
      }
      return garmentUrl;
    }

    function getCameraVideoConstraints() {
      if (cameraFacingMode === "environment") {
        return {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        };
      }
      return {
        facingMode: "user",
        aspectRatio: { ideal: 4 / 5 },
        width: { ideal: 864 },
        height: { ideal: 1080 }
      };
    }

    async function attachLiveCameraStream() {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: getCameraVideoConstraints()
        });
      } catch (firstErr) {
        if (cameraFacingMode === "environment") {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { ideal: "environment" } }
          });
        } else {
          throw firstErr;
        }
      }
      video.srcObject = stream;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.muted = true;
      await video.play();
    }

    function stopCamera() {
      isCameraCaptureInProgress = false;
      bodySeenStreak = 0;
      bodyLostStreak = 0;
      lastHumanDetected = false;
      lastLiveFaceDetected = false;
      lastLiveFaceDetectedAt = 0;
      humanCheckInFlight = false;
      poseMissStreak = 0;
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      setCountdownValue("");
      if (bodyCheckTimer) {
        clearInterval(bodyCheckTimer);
        bodyCheckTimer = null;
      }
      if (captureTimer) {
        clearTimeout(captureTimer);
        captureTimer = null;
      }
      poseLoopActive = false;
      poseFramePending = false;
      latestPoseLandmarks = null;
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
        stream = null;
      }
      if (video) {
        video.srcObject = null;
      }
    }

    function getLandmark(index) {
      return latestPoseLandmarks && latestPoseLandmarks[index] ? latestPoseLandmarks[index] : null;
    }

    function hasVisibility(landmark, min) {
      return !!landmark && typeof landmark.visibility === "number" && landmark.visibility >= min;
    }

    function hasHalfBodyInView() {
      if (!latestPoseLandmarks || !latestPoseLandmarks.length) {
        return false;
      }

      var relaxed = cameraFacingMode === "environment";
      var torsoMin = relaxed ? 0.42 : 0.5;
      var limbMin = relaxed ? 0.32 : 0.45;
      var minTorsoSpan = relaxed ? 0.11 : 0.18;

      var leftShoulder = getLandmark(11);
      var rightShoulder = getLandmark(12);
      var leftHip = getLandmark(23);
      var rightHip = getLandmark(24);
      var leftKnee = getLandmark(25);
      var rightKnee = getLandmark(26);
      var leftAnkle = getLandmark(27);
      var rightAnkle = getLandmark(28);

      var torsoDetected =
        hasVisibility(leftShoulder, torsoMin) &&
        hasVisibility(rightShoulder, torsoMin) &&
        hasVisibility(leftHip, torsoMin) &&
        hasVisibility(rightHip, torsoMin);
      if (!torsoDetected) {
        return false;
      }

      var lowerBodyDetected =
        hasVisibility(leftKnee, limbMin) ||
        hasVisibility(rightKnee, limbMin) ||
        hasVisibility(leftAnkle, limbMin) ||
        hasVisibility(rightAnkle, limbMin);
      if (!lowerBodyDetected) {
        return false;
      }

      var shoulderY = (leftShoulder.y + rightShoulder.y) / 2;
      var hipY = (leftHip.y + rightHip.y) / 2;
      return hipY - shoulderY > minTorsoSpan;
    }

    function withTimeout(promise, ms, fallbackValue) {
      return Promise.race([
        promise,
        new Promise(function (resolve) {
          setTimeout(function () {
            resolve(fallbackValue);
          }, ms);
        })
      ]);
    }

    function isLikelyBlankImage(source) {
      try {
        var w = source.width || source.videoWidth || source.naturalWidth || 0;
        var h = source.height || source.videoHeight || source.naturalHeight || 0;
        if (w < 2 || h < 2) {
          return true;
        }
        var sample = document.createElement("canvas");
        sample.width = 32;
        sample.height = 32;
        var ctx = sample.getContext("2d");
        ctx.drawImage(source, 0, 0, 32, 32);
        var data = ctx.getImageData(0, 0, 32, 32).data;
        var sum = 0;
        var sumSq = 0;
        var n = 0;
        var i = 0;
        for (i = 0; i < data.length; i += 4) {
          var lum = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
          sum += lum;
          sumSq += lum * lum;
          n += 1;
        }
        var mean = sum / n;
        var variance = sumSq / n - mean * mean;
        return variance < 80;
      } catch (blankErr) {
        return false;
      }
    }

    function hasPersonInLandmarks(landmarks) {
      if (!landmarks || !landmarks.length) {
        return false;
      }
      var minVis = cameraFacingMode === "environment" ? 0.22 : 0.4;
      var torsoMin = cameraFacingMode === "environment" ? 0.42 : 0.5;
      var limbMin = cameraFacingMode === "environment" ? 0.32 : 0.45;
      var nose = hasVisibility(landmarks[0], minVis);
      var leftShoulder = landmarks[11];
      var rightShoulder = landmarks[12];
      var leftHip = landmarks[23];
      var rightHip = landmarks[24];
      var leftKnee = landmarks[25];
      var rightKnee = landmarks[26];
      var leftAnkle = landmarks[27];
      var rightAnkle = landmarks[28];
      var hasShoulder =
        hasVisibility(leftShoulder, minVis) || hasVisibility(rightShoulder, minVis);
      var hasHip = hasVisibility(leftHip, minVis) || hasVisibility(rightHip, minVis);

      if (
        hasVisibility(leftShoulder, torsoMin) &&
        hasVisibility(rightShoulder, torsoMin) &&
        hasVisibility(leftHip, torsoMin) &&
        hasVisibility(rightHip, torsoMin)
      ) {
        var lowerBodyDetected =
          hasVisibility(leftKnee, limbMin) ||
          hasVisibility(rightKnee, limbMin) ||
          hasVisibility(leftAnkle, limbMin) ||
          hasVisibility(rightAnkle, limbMin);
        if (lowerBodyDetected) {
          return true;
        }
      }

      if (nose && hasShoulder) {
        return true;
      }
      if (hasShoulder && hasHip) {
        return true;
      }
      return false;
    }

    function isStrictHumanInView() {
      if (!video || currentState !== "camera") {
        return false;
      }
      if ((video.videoWidth || 0) < 2 || (video.videoHeight || 0) < 2) {
        return false;
      }
      if (isLikelyBlankImage(video)) {
        return false;
      }
      if (latestPoseLandmarks && hasPersonInLandmarks(latestPoseLandmarks)) {
        return true;
      }
      if (
        lastLiveFaceDetected &&
        lastLiveFaceDetectedAt &&
        Date.now() - lastLiveFaceDetectedAt <= LIVE_FACE_MAX_AGE_MS
      ) {
        return true;
      }
      return false;
    }

    function isCaptureAllowed() {
      return bodySeenStreak >= BODY_SEEN_CHECKS && isStrictHumanInView();
    }

    function getCaptureBlockedReason() {
      if (currentState !== "camera" || isLoading) {
        return "";
      }
      if (isCameraCaptureInProgress) {
        return "Capturing…";
      }
      if (isCaptureAllowed()) {
        return "";
      }
      if (!video || (video.videoWidth || 0) < 2 || (video.videoHeight || 0) < 2) {
        return "Camera is loading. Please wait a moment.";
      }
      if (isLikelyBlankImage(video)) {
        return "Camera view is unclear. Point the camera at yourself.";
      }
      if (!latestPoseLandmarks && !lastLiveFaceDetected && bodySeenStreak === 0) {
        return "No person detected. Stand in the middle of the frame.";
      }
      if (bodySeenStreak > 0 && bodySeenStreak < BODY_SEEN_CHECKS) {
        return "Hold still — confirming your position…";
      }
      return "Stand in the middle so your body is visible.";
    }

    function runOneShotPose(source) {
      return new Promise(function (resolve) {
        if (!window.Pose || !source) {
          resolve(null);
          return;
        }
        var sw = source.videoWidth || source.naturalWidth || source.width || 1;
        var sh = source.videoHeight || source.naturalHeight || source.height || 1;
        if (sw < 2 || sh < 2) {
          resolve(null);
          return;
        }
        var poseCanvas = document.createElement("canvas");
        var maxSide = 480;
        var scale = Math.min(1, maxSide / Math.max(sw, sh));
        poseCanvas.width = Math.max(2, Math.round(sw * scale));
        poseCanvas.height = Math.max(2, Math.round(sh * scale));
        poseCanvas.getContext("2d").drawImage(source, 0, 0, poseCanvas.width, poseCanvas.height);

        var settled = false;
        function finish(result) {
          if (settled) {
            return;
          }
          settled = true;
          resolve(result);
        }

        var oneShotPose = new window.Pose({
          locateFile: function (f) {
            return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + f;
          }
        });
        var rear = cameraFacingMode === "environment";
        oneShotPose.setOptions({
          modelComplexity: 0,
          smoothLandmarks: false,
          enableSegmentation: false,
          minDetectionConfidence: rear ? 0.3 : 0.35,
          minTrackingConfidence: rear ? 0.3 : 0.35
        });
        oneShotPose.onResults(function (results) {
          try {
            oneShotPose.close();
          } catch (closeErr) {
            /* ignore */
          }
          finish(results && results.poseLandmarks ? results.poseLandmarks : null);
        });
        oneShotPose.send({ image: poseCanvas }).catch(function () {
          try {
            oneShotPose.close();
          } catch (closeErr2) {
            /* ignore */
          }
          finish(null);
        });
      });
    }

    async function ensureFaceDetectorReady() {
      if (faceDetectorReady) {
        return;
      }
      var waited = 0;
      while (!window.FaceDetection && waited < 8000) {
        await new Promise(function (r) {
          setTimeout(r, 200);
        });
        waited += 200;
      }
      if (!window.FaceDetection) {
        return;
      }
      faceDetector = new window.FaceDetection({
        locateFile: function (file) {
          return "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/" + file;
        }
      });
      faceDetector.setOptions({
        model: "short",
        minDetectionConfidence: cameraFacingMode === "environment" ? 0.4 : 0.5
      });
      faceDetector.onResults(function (results) {
        var found = results && results.detections && results.detections.length > 0;
        var next = faceDetectQueue.shift();
        if (next) {
          next(found);
        }
      });
      faceDetectorReady = true;
    }

    async function detectFaceInSource(source, minConfidence) {
      await ensureFaceDetectorReady();
      if (!faceDetector) {
        return false;
      }
      if (typeof faceDetector.setOptions === "function") {
        var gateConfidence =
          typeof minConfidence === "number"
            ? minConfidence
            : cameraFacingMode === "environment"
              ? 0.35
              : 0.4;
        faceDetector.setOptions({
          model: "short",
          minDetectionConfidence: gateConfidence
        });
      }
      var sendTarget = source;
      if (source && source.tagName === "IMG") {
        var tmpC = document.createElement("canvas");
        tmpC.width = source.naturalWidth || source.width || 1;
        tmpC.height = source.naturalHeight || source.height || 1;
        tmpC.getContext("2d").drawImage(source, 0, 0);
        sendTarget = tmpC;
      }
      return new Promise(function (resolve) {
        faceDetectQueue.push(resolve);
        faceDetector.send({ image: sendTarget }).catch(function () {
          var idx = faceDetectQueue.indexOf(resolve);
          if (idx !== -1) {
            faceDetectQueue.splice(idx, 1);
          }
          resolve(false);
        });
      });
    }

    async function evaluateLiveHuman() {
      if (!video || currentState !== "camera") {
        return false;
      }
      if ((video.videoWidth || 0) < 2 || (video.videoHeight || 0) < 2) {
        return false;
      }
      if (isLikelyBlankImage(video)) {
        lastLiveFaceDetected = false;
        return false;
      }
      if (latestPoseLandmarks && hasPersonInLandmarks(latestPoseLandmarks)) {
        return true;
      }
      var faceFound = await withTimeout(detectFaceInSource(video), 700, false);
      if (faceFound) {
        lastLiveFaceDetected = true;
        lastLiveFaceDetectedAt = Date.now();
        return true;
      }
      lastLiveFaceDetected = false;
      return false;
    }

    async function confirmHumanInCapture(sourceCanvas) {
      if (!sourceCanvas || isLikelyBlankImage(sourceCanvas)) {
        return false;
      }
      if (latestPoseLandmarks && hasPersonInLandmarks(latestPoseLandmarks)) {
        return true;
      }
      var faceFound = await withTimeout(
        detectFaceInSource(sourceCanvas),
        CAPTURE_CONFIRM_TIMEOUT_MS,
        false
      );
      if (faceFound) {
        return true;
      }
      var freshLandmarks = await withTimeout(
        runOneShotPose(sourceCanvas),
        POSE_CHECK_TIMEOUT_MS,
        null
      );
      if (freshLandmarks && freshLandmarks.length) {
        latestPoseLandmarks = freshLandmarks;
        return hasPersonInLandmarks(freshLandmarks);
      }
      return false;
    }

    /** Reject upload/camera stills that are not a clear person photo. */
    async function validatePersonStillImage(imgEl) {
      if (!imgEl || isLikelyBlankImage(imgEl)) {
        return { ok: false, message: "Image is unclear. Please use a clear photo of yourself." };
      }
      if (!window.FaceDetection && !window.Pose) {
        return { ok: true };
      }
      try {
        var faceFound = await withTimeout(
          detectFaceInSource(imgEl),
          FACE_CHECK_TIMEOUT_MS,
          false
        );
        if (faceFound) {
          return { ok: true };
        }
      } catch (faceErr) {
        /* fall through to pose */
      }
      var landmarks = await withTimeout(runOneShotPose(imgEl), POSE_CHECK_TIMEOUT_MS, null);
      if (landmarks && landmarks.length && hasPersonInLandmarks(landmarks)) {
        return { ok: true };
      }
      return {
        ok: false,
        message: "No person detected. Please use a clear front-facing photo of yourself."
      };
    }

    async function ensurePoseReady() {
      if (poseReady) {
        return;
      }
      var waited = 0;
      while (!window.Pose && waited < 8000) {
        await new Promise(function (r) {
          setTimeout(r, 200);
        });
        waited += 200;
      }
      if (!window.Pose) {
        throw new Error("MediaPipe not loaded. Please refresh.");
      }

      pose = new window.Pose({
        locateFile: function (file) {
          return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + file;
        }
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: false,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(function (results) {
        if (results && results.poseLandmarks && results.poseLandmarks.length) {
          poseMissStreak = 0;
          latestPoseLandmarks = results.poseLandmarks;
          if (hasPersonInLandmarks(results.poseLandmarks)) {
            lastHumanDetected = true;
          }
        } else {
          poseMissStreak += 1;
          if (poseMissStreak >= 1) {
            latestPoseLandmarks = null;
          }
          if (poseMissStreak >= 4) {
            lastHumanDetected = false;
          }
        }
      });

      poseReady = true;
    }

    function syncPoseConfidenceForFacing() {
      if (!pose || typeof pose.setOptions !== "function") {
        return;
      }
      var rear = cameraFacingMode === "environment";
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: false,
        minDetectionConfidence: rear ? 0.38 : 0.5,
        minTrackingConfidence: rear ? 0.38 : 0.5
      });
    }

    async function runPoseLoop() {
      if (!pose || !poseLoopActive || !video || !stream) {
        return;
      }
      if (poseFramePending) {
        requestAnimationFrame(runPoseLoop);
        return;
      }

      poseFramePending = true;
      try {
        await pose.send({ image: video });
      } catch (error) {
        // Continue inference loop even if one frame fails.
      }
      poseFramePending = false;

      if (poseLoopActive) {
        requestAnimationFrame(runPoseLoop);
      }
    }

    function startCountdownIfEligible(skipPoseCheck) {
      if (countdownInterval || currentState !== "camera" || isCameraCaptureInProgress) {
        return;
      }
      if (!skipPoseCheck && !hasHalfBodyInView()) {
        return;
      }

      var rear = skipPoseCheck === true;
      var seconds = 5;
      var statusLine = rear
        ? "Back camera — capturing in " + seconds + "…"
        : "Body detected. Capturing in " + seconds + "…";
      var instruct = rear ? "Hold steady. Stay in frame." : "Body detected. Capturing in " + seconds + "…";
      setStatus(statusLine);
      setCameraInstruction(instruct);
      setCountdownValue(seconds);
      countdownInterval = setInterval(function () {
        seconds -= 1;
        if (seconds <= 0) {
          clearInterval(countdownInterval);
          countdownInterval = null;
          setCountdownValue("");
          isCameraCaptureInProgress = true;
          captureFromCamera().finally(function () {
            isCameraCaptureInProgress = false;
          });
          return;
        }
        statusLine = rear ? "Back camera — capturing in " + seconds + "…" : "Body detected. Capturing in " + seconds + "…";
        instruct = rear ? "Hold steady. Stay in frame." : "Body detected. Capturing in " + seconds + "…";
        setStatus(statusLine);
        setCameraInstruction(instruct);
        setCountdownValue(seconds);
      }, 1000);
    }

    function startBodyMonitor() {
      bodySeenStreak = 0;
      bodyLostStreak = 0;
      lastHumanDetected = false;
      lastLiveFaceDetected = false;
      lastLiveFaceDetectedAt = 0;
      humanCheckInFlight = false;
      if (bodyCheckTimer) {
        clearInterval(bodyCheckTimer);
      }
      bodyCheckTimer = setInterval(function () {
        if (currentState !== "camera" || isCameraCaptureInProgress) {
          return;
        }

        if (humanCheckInFlight || !video) {
          return;
        }

        humanCheckInFlight = true;
        withTimeout(evaluateLiveHuman(), 1800, false)
          .then(function (detected) {
            humanCheckInFlight = false;
            if (currentState !== "camera" || isCameraCaptureInProgress) {
              return;
            }
            lastHumanDetected = detected;
            if (detected) {
              bodyLostStreak = 0;
              bodySeenStreak += 1;
            } else {
              bodySeenStreak = 0;
              bodyLostStreak += 1;
              if (bodyLostStreak >= BODY_LOST_CHECKS) {
                lastHumanDetected = false;
              }
            }

            if (isCaptureAllowed()) {
              setStatus("Body detected. Press Capture.");
              setCameraInstruction("Body detected. Press Capture.");
            } else if (bodyLostStreak >= BODY_LOST_CHECKS || !detected) {
              if (countdownInterval) {
                clearInterval(countdownInterval);
                countdownInterval = null;
                setCountdownValue("");
              }
              setStatus("Stand in middle for accurate outputs.");
              setCameraInstruction("Stand in middle for accurate outputs.");
            }
          })
          .catch(function () {
            humanCheckInFlight = false;
          });
      }, 400);
    }

    function getCaptureCrop(videoWidth, videoHeight) {
      var targetRatio = 4 / 5;
      var cropWidth = videoWidth;
      var cropHeight = videoHeight;

      if (videoWidth / videoHeight > targetRatio) {
        cropWidth = videoHeight * targetRatio;
      } else {
        cropHeight = videoWidth / targetRatio;
      }

      var cropX = (videoWidth - cropWidth) / 2;
      var cropY = (videoHeight - cropHeight) / 2;
      var centeringPoints = [getLandmark(11), getLandmark(12), getLandmark(23), getLandmark(24)].filter(function (point) {
        return point && typeof point.x === "number";
      });

      if (centeringPoints.length) {
        var avgX =
          centeringPoints.reduce(function (sum, point) {
            return sum + point.x;
          }, 0) / centeringPoints.length;
        var desiredX = avgX * videoWidth - cropWidth / 2;
        cropX = Math.max(0, Math.min(desiredX, videoWidth - cropWidth));
      }

      return {
        sx: cropX,
        sy: cropY,
        sw: cropWidth,
        sh: cropHeight
      };
    }

    function getTargetCaptureSize() {
      var targetHeight = 1250;
      var targetWidth = Math.round((targetHeight * 4) / 5);
      return {
        width: targetWidth,
        height: targetHeight
      };
    }

    async function blobToDataUrl(fileBlob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result || "");
        };
        reader.onerror = function () {
          reject(new Error("Failed to read image."));
        };
        reader.readAsDataURL(fileBlob);
      });
    }

    function stripDataUrlToRawBase64(dataUrl) {
      if (!dataUrl || typeof dataUrl !== "string") {
        return "";
      }
      var trimmed = dataUrl.trim();
      var marker = "base64,";
      var idx = trimmed.indexOf(marker);
      if (idx !== -1) {
        return trimmed.slice(idx + marker.length);
      }
      return trimmed;
    }

    function canvasToJpegBlob(canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(
          function (blob) {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Could not encode JPEG."));
            }
          },
          "image/jpeg",
          TRYON_JPEG_QUALITY
        );
      });
    }

    async function blobToJpegBase64(fileBlob) {
      var jpegBlob = fileBlob;
      var type = (fileBlob && fileBlob.type) || "";
      if (type.indexOf("jpeg") === -1 && type.indexOf("jpg") === -1) {
        var sourceUrl = URL.createObjectURL(fileBlob);
        try {
          var sourceImage = await imageFromUrl(sourceUrl);
          var tempCanvas = document.createElement("canvas");
          tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
          tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
          tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
          jpegBlob = await canvasToJpegBlob(tempCanvas);
        } finally {
          URL.revokeObjectURL(sourceUrl);
        }
      }
      var dataUrl = await blobToDataUrl(jpegBlob);
      return {
        base64: stripDataUrlToRawBase64(dataUrl),
        mimeType: "image/jpeg"
      };
    }

    async function imageUrlToJpegBase64(imageUrl) {
      var sourceImage;
      try {
        sourceImage = await imageFromUrl(imageUrl, true);
      } catch (corsErr) {
        sourceImage = await imageFromUrl(imageUrl, false);
      }
      var tempCanvas = document.createElement("canvas");
      tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
      tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
      tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
      var jpegBlob = await canvasToJpegBlob(tempCanvas);
      var dataUrl = await blobToDataUrl(jpegBlob);
      return {
        base64: stripDataUrlToRawBase64(dataUrl),
        mimeType: "image/jpeg"
      };
    }

    function findDecodableImageFromJson(node, depth) {
      depth = depth || 0;
      if (!node || depth > 12) {
        return null;
      }
      if (typeof node === "string") {
        try {
          var blob = dataUrlToBlob(node);
          return blob && blob.size > 0 ? blob : null;
        } catch (decodeErr) {
          return null;
        }
      }
      if (Array.isArray(node)) {
        var i;
        for (i = 0; i < node.length; i++) {
          var fromArray = findDecodableImageFromJson(node[i], depth + 1);
          if (fromArray) {
            return fromArray;
          }
        }
        return null;
      }
      if (typeof node !== "object") {
        return null;
      }
      var preferredKeys = [
        "resultImageBase64",
        "result_image_base64",
        "image",
        "result_image",
        "image_base64",
        "result",
        "output",
        "data",
        "url",
        "image_url",
        "result_url"
      ];
      var k;
      for (k = 0; k < preferredKeys.length; k++) {
        if (node[preferredKeys[k]] != null) {
          var fromKey = findDecodableImageFromJson(node[preferredKeys[k]], depth + 1);
          if (fromKey) {
            return fromKey;
          }
        }
      }
      for (var key in node) {
        if (Object.prototype.hasOwnProperty.call(node, key)) {
          var nested = findDecodableImageFromJson(node[key], depth + 1);
          if (nested) {
            return nested;
          }
        }
      }
      return null;
    }

    function rawBase64ToBlob(base64, mimeType) {
      if (!base64 || typeof base64 !== "string") {
        return null;
      }
      var normalized = base64.trim();
      if (!normalized) {
        return null;
      }
      if (normalized.indexOf("data:") === 0) {
        return dataUrlToBlob(normalized);
      }
      var mime = mimeType && typeof mimeType === "string" ? mimeType.trim() : "image/png";
      return dataUrlToBlob("data:" + mime + ";base64," + normalized);
    }

    async function parseTryonSuccessResponse(response) {
      var contentType = (response.headers.get("Content-Type") || "").toLowerCase();
      if (contentType.indexOf("image/") !== -1) {
        return response.blob();
      }
      var bodyText = await response.text();
      var data = null;
      try {
        data = JSON.parse(bodyText);
      } catch (parseErr) {
        throw new Error("Try-on API returned a non-image, non-JSON response.");
      }
      if (data && data.success === false) {
        throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
      }
      if (data && typeof data.resultImageBase64 === "string" && data.resultImageBase64.trim()) {
        var resultBlob = rawBase64ToBlob(data.resultImageBase64, data.mimeType);
        if (resultBlob && resultBlob.size > 0) {
          return resultBlob;
        }
        throw new Error("Try-on API returned an invalid result image.");
      }
      var blob = findDecodableImageFromJson(data);
      if (blob) {
        return blob;
      }
      var urlCandidate =
        data &&
        (data.result_url ||
          data.image_url ||
          data.url ||
          (data.output && (data.output.url || data.output.result_url)));
      if (urlCandidate && typeof urlCandidate === "string") {
        return urlToBlob(urlCandidate);
      }
      throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
    }

    async function urlToBlob(imageUrl) {
      var response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error("Could not load generated image.");
      }
      return response.blob();
    }

    function dataUrlToBlob(value) {
      if (!value || typeof value !== "string") {
        return null;
      }

      var normalized = value.trim();
      if (!normalized) {
        return null;
      }

      // Support both full data URLs and raw base64 payloads.
      if (normalized.indexOf("data:") !== 0) {
        normalized = "data:image/jpeg;base64," + normalized;
      }

      var parts = normalized.split(",");
      if (parts.length < 2) {
        return null;
      }

      var header = parts[0];
      var base64 = parts.slice(1).join(",");
      var mimeMatch = header.match(/data:(.*?);base64/);
      var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : "image/jpeg";
      var binary = atob(base64);
      var length = binary.length;
      var bytes = new Uint8Array(length);

      for (var i = 0; i < length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
      }

      return new Blob([bytes], { type: mimeType });
    }

    async function imageFromUrl(imageUrl, useCrossOrigin) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        if (useCrossOrigin) {
          image.crossOrigin = "anonymous";
        }
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          reject(new Error("Failed to decode image."));
        };
        image.src = imageUrl;
      });
    }

    async function applyWatermark(inputBlob) {
      try {
        var sourceUrl = URL.createObjectURL(inputBlob);
        var sourceImage = await imageFromUrl(sourceUrl);
        URL.revokeObjectURL(sourceUrl);

        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = sourceImage.width;
        tempCanvas.height = sourceImage.height;
        var ctx = tempCanvas.getContext("2d");
        ctx.drawImage(sourceImage, 0, 0, sourceImage.width, sourceImage.height);

        var fontSize = Math.max(22, Math.round(sourceImage.width * 0.06));
        ctx.save();
        ctx.translate(sourceImage.width / 2, sourceImage.height / 2);
        ctx.rotate((-12 * Math.PI) / 180);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "700 " + fontSize + "px Arial, sans-serif";
        ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.08));
        ctx.strokeStyle = "rgba(0, 0, 0, 0.24)";
        ctx.fillStyle = "rgba(255, 255, 255, 0.4)";
        ctx.strokeText("BHARAT RESHMA", 0, 0);
        ctx.fillText("BHARAT RESHMA", 0, 0);
        ctx.restore();

        var finalBlob = await new Promise(function (resolve) {
          tempCanvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
        });
        if (!finalBlob) {
          console.warn("[TryOn] Canvas toBlob returned null. Returning original image.");
        }
        return finalBlob || inputBlob;
      } catch (error) {
        console.error("[TryOn] Watermark apply failed.", error);
        return inputBlob;
      }
    }

    function getOtpEndpoint() {
      return String(modal.dataset.otpEndpoint || "").trim().replace(/\/$/, "");
    }

    function buildOtpRequestUrl(action) {
      var endpoint = getOtpEndpoint();
      if (!endpoint) {
        return "";
      }
      if (endpoint.indexOf("script.google.com") !== -1) {
        return endpoint;
      }
      return endpoint + "/otp/" + action;
    }

    function setDetailsFormStep(step) {
      var isOtp = step === "otp";
      if (detailsStepDetails) {
        detailsStepDetails.hidden = isOtp;
      }
      if (detailsStepOtp) {
        detailsStepOtp.hidden = !isOtp;
      }
      if (detailsSubmitButton) {
        detailsSubmitButton.textContent = isOtp ? "Verify" : "Send OTP";
      }
      detailsSubmitLabel = isOtp ? "Verify" : "Send OTP";
    }

    function clearOtpResendCooldown() {
      if (otpResendCooldownTimer) {
        clearTimeout(otpResendCooldownTimer);
        otpResendCooldownTimer = null;
      }
      if (otpResendButton) {
        otpResendButton.disabled = false;
        otpResendButton.textContent = "Resend code";
      }
    }

    function setOtpResendCooldown() {
      if (!otpResendButton) {
        return;
      }
      clearOtpResendCooldown();
      var remaining = Math.ceil(OTP_RESEND_COOLDOWN_MS / 1000);
      otpResendButton.disabled = true;
      otpResendButton.textContent = "Resend in " + remaining + "s";
      var interval = setInterval(function () {
        remaining -= 1;
        if (remaining <= 0) {
          clearInterval(interval);
          otpResendButton.disabled = false;
          otpResendButton.textContent = "Resend code";
          otpResendCooldownTimer = null;
          return;
        }
        otpResendButton.textContent = "Resend in " + remaining + "s";
      }, 1000);
      otpResendCooldownTimer = interval;
    }

    function collectValidatedDetailsPayload() {
      var name = (detailsNameInput.value || "").trim();
      var dialCode = getTryOnDialCode(detailsPhoneCodeSelect);
      var countryIso = getTryOnCountryIso(detailsPhoneCodeSelect);
      var nationalPhone = normalizeNationalPhoneDigits(
        detailsPhoneInput.value,
        TRYON_PHONE_MAX_LEN
      );
      detailsPhoneInput.value = nationalPhone;
      var phone = buildInternationalPhone(dialCode, nationalPhone);
      var missingName = !name;
      var missingPhone = !nationalPhone;
      var invalidPhone = !isValidInternationalPhone(dialCode, nationalPhone, countryIso);
      var consentGiven = detailsConsentInput && detailsConsentInput.checked;

      setInputErrorState(detailsNameInput, missingName);
      setInputErrorState(detailsPhoneInput, missingPhone || invalidPhone);
      if (detailsPhoneCodeSelect) {
        setInputErrorState(detailsPhoneCodeSelect, missingPhone || invalidPhone);
      }

      if (!name || !nationalPhone) {
        setDetailsError("Please enter both name and mobile number.");
        return null;
      }
      if (invalidPhone) {
        setDetailsError(getTryOnPhoneValidationMessage(nationalPhone));
        return null;
      }
      if (!consentGiven) {
        setDetailsError("Please give consent for BR team to contact.");
        return null;
      }
      setDetailsError("");
      return {
        name: name,
        countryCode: dialCode,
        mobile: nationalPhone,
        phone: phone,
        consent: true
      };
    }

    async function requestOtpSend(phone) {
      var url = buildOtpRequestUrl("send");
      if (!url) {
        throw new Error("OTP service is not configured.");
      }
      var response = await fetch(url, {
        method: "POST",
        redirect: "follow",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ phone: phone })
      });
      var rawText = "";
      try {
        rawText = await response.text();
      } catch (readErr) {
        rawText = "";
      }
      var data = null;
      if (rawText) {
        try {
          data = JSON.parse(rawText);
        } catch (parseErr) {
          data = null;
        }
      }
      var isSuccess = data && (data.success === true || data.ok === true);
      if (!isSuccess) {
        throw new Error((data && data.error) || "Could not send verification code.");
      }
    }

    async function requestOtpVerify(phone, code) {
      var url = buildOtpRequestUrl("verify");
      if (!url) {
        throw new Error("OTP service is not configured.");
      }
      var response = await fetch(url, {
        method: "POST",
        redirect: "follow",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ phone: phone, code: code })
      });
      var rawText = "";
      try {
        rawText = await response.text();
      } catch (readErr) {
        rawText = "";
      }
      var data = null;
      if (rawText) {
        try {
          data = JSON.parse(rawText);
        } catch (parseErr) {
          data = null;
        }
      }
      var isVerified = data && data.success === true && data.verified === true;
      if (!isVerified) {
        throw new Error((data && data.error) || "Incorrect or expired code.");
      }
    }

    async function submitCustomerDetails(payload, options) {
      options = options || {};
      var url = modal.dataset.detailsEndpoint;
      if (!url || !payload) {
        console.warn("[TryOn] Sheet submit skipped: missing endpoint or payload.", { url: !!url, payload: !!payload });
        return;
      }
      var dialCode = String(payload.countryCode || "").replace(/\D/g, "");
      var websiteUrl = String(
        payload.websiteUrl ||
          modal.dataset.tryonWebsiteUrl ||
          modal.dataset.tryonStoreOrigin ||
          ""
      )
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(payload.productUrl || modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var productTitle = String(payload.productTitle || modal.dataset.tryonProductTitle || "").trim();
      var bodyObj = {
        name: payload.name,
        countryCode: dialCode ? "+" + dialCode : "",
        phone: payload.mobile || "",
        consent: !!payload.consent,
        phoneVerified: payload.phoneVerified === true,
        websiteUrl: websiteUrl,
        productUrl: productUrl,
        productTitle: productTitle,
        phone_verified: payload.phoneVerified === true ? "Yes" : "No",
        website_url: websiteUrl,
        product_url: productUrl,
        product_title: productTitle,
        mergeProductUrl: options.mergeProductUrl === true
      };
      console.info("[TryOn] Sheet submit →", url, bodyObj);
      var response = await fetch(url, {
        method: "POST",
        redirect: "follow",
        cache: "no-store",
        headers: {
          "Content-Type": "text/plain;charset=utf-8"
        },
        body: JSON.stringify(bodyObj)
      });
      var rawText = "";
      try {
        rawText = await response.text();
      } catch (readErr) {
        rawText = "";
      }
      var data = null;
      if (rawText) {
        try {
          data = JSON.parse(rawText);
        } catch (parseErr) {
          data = null;
        }
      }
      var isSuccess = data && (data.ok === true || data.success === true);
      if (!isSuccess) {
        throw new Error((data && data.error) || "Could not save details to sheet.");
      }
      console.info("[TryOn] Sheet saved:", data);
    }

    async function completeVerifiedSubmission(payload) {
      var websiteUrl = String(modal.dataset.tryonWebsiteUrl || modal.dataset.tryonStoreOrigin || "")
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var enriched = {
        name: payload.name,
        countryCode: payload.countryCode,
        mobile: payload.mobile,
        phone: payload.phone,
        consent: true,
        phoneVerified: true,
        websiteUrl: websiteUrl,
        productUrl: productUrl,
        productTitle: String(modal.dataset.tryonProductTitle || "").trim()
      };
      await submitCustomerDetails(enriched);
      persistContactSubmitted(enriched);
    }

    /** Re-log try-on on 3rd+ generation: same contact, current page product/website. */
    function submitStoredContactForCurrentProduct() {
      var state = readDailyState();
      if (!state.contactSubmitted || !state.contact) {
        return Promise.resolve();
      }
      var contact = state.contact;
      var websiteUrl = String(modal.dataset.tryonWebsiteUrl || modal.dataset.tryonStoreOrigin || "")
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      return submitCustomerDetails(
        {
          name: contact.name,
          countryCode: contact.countryCode,
          mobile: contact.mobile,
          phone:
            contact.phone ||
            buildInternationalPhone(contact.countryCode, contact.mobile),
          consent: true,
          phoneVerified: contact.phoneVerified === true,
          websiteUrl: websiteUrl,
          productUrl: productUrl,
          productTitle: String(modal.dataset.tryonProductTitle || "").trim()
        },
        { mergeProductUrl: true }
      );
    }

    function downloadBlob(blob, filename) {
      var fileUrl = URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = filename || "try-on-result.jpg";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(fileUrl);
    }

    function askCustomerDetails(actionLabel) {
      if (!detailsModal || !detailsNameInput || !detailsPhoneInput || !detailsSubmitButton || !detailsCancelButton) {
        return Promise.resolve(null);
      }

      return new Promise(function (resolve) {
        var currentStep = "details";
        var pendingPayload = null;

        function cleanupListeners() {
          detailsSubmitButton.removeEventListener("click", submitHandler);
          detailsCancelButton.removeEventListener("click", cancelHandler);
          detailsModal.removeEventListener("click", overlayHandler);
          if (otpResendButton) {
            otpResendButton.removeEventListener("click", resendHandler);
          }
          if (otpChangeButton) {
            otpChangeButton.removeEventListener("click", changeNumberHandler);
          }
          clearOtpResendCooldown();
        }

        function closePopup(result) {
          cleanupListeners();
          setDetailsSubmitBusy(false);
          detailsModal.hidden = true;
          modal.classList.remove("br-tryon-modal--details-open");
          pendingOtpPhone = "";
          pendingPayload = null;
          resolve(result);
        }

        async function sendOtpStep(payload) {
          pendingPayload = payload;
          pendingOtpPhone = payload.phone;
          try {
            await requestOtpSend(payload.phone);
            if (otpHintNode) {
              otpHintNode.textContent =
                "Enter the 6-digit code sent on WhatsApp to " + payload.phone + ".";
            }
            if (otpInput) {
              otpInput.value = "";
            }
            currentStep = "otp";
            setDetailsFormStep("otp");
            setOtpResendCooldown();
            setDetailsSubmitBusy(false);
            if (otpInput) {
              otpInput.focus();
            }
          } catch (error) {
            setDetailsSubmitBusy(false);
            setDetailsError((error && error.message) || "Could not send verification code.");
          }
        }

        async function verifyOtpStep() {
          if (!pendingPayload || !pendingOtpPhone) {
            setDetailsError("Please send OTP again.");
            currentStep = "details";
            setDetailsFormStep("details");
            return;
          }
          var code = String((otpInput && otpInput.value) || "").trim();
          if (!/^\d{4,8}$/.test(code)) {
            setDetailsError("Enter the verification code from WhatsApp.");
            return;
          }
          setDetailsError("");
          setDetailsSubmitBusy(true, "Verifying…");
          try {
            await requestOtpVerify(pendingOtpPhone, code);
            await completeVerifiedSubmission(pendingPayload);
            closePopup(pendingPayload);
          } catch (error) {
            setDetailsSubmitBusy(false);
            setDetailsError((error && error.message) || "Could not verify code.");
          }
        }

        function submitHandler() {
          if (isDetailsSubmitBusy) {
            return;
          }
          if (currentStep === "otp") {
            verifyOtpStep();
            return;
          }
          var payload = collectValidatedDetailsPayload();
          if (!payload) {
            return;
          }
          if (!getOtpEndpoint()) {
            setDetailsError("OTP service is not configured.");
            return;
          }
          setDetailsSubmitBusy(true, "Sending OTP…");
          sendOtpStep(payload);
        }

        async function resendHandler() {
          if (isDetailsSubmitBusy || !pendingOtpPhone || otpResendButton.disabled) {
            return;
          }
          setDetailsError("");
          setDetailsSubmitBusy(true, "Resending…");
          try {
            await requestOtpSend(pendingOtpPhone);
            setOtpResendCooldown();
            setDetailsSubmitBusy(false);
            setDetailsError("");
          } catch (error) {
            setDetailsSubmitBusy(false);
            setDetailsError((error && error.message) || "Could not resend code.");
          }
        }

        function changeNumberHandler() {
          if (isDetailsSubmitBusy) {
            return;
          }
          currentStep = "details";
          pendingOtpPhone = "";
          setDetailsFormStep("details");
          setDetailsError("");
          if (otpInput) {
            otpInput.value = "";
          }
          clearOtpResendCooldown();
          detailsNameInput.focus();
        }

        function cancelHandler() {
          if (isDetailsSubmitBusy) {
            return;
          }
          closePopup(null);
        }

        function overlayHandler(event) {
          if (event.target === detailsModal) {
            if (isDetailsSubmitBusy) {
              return;
            }
            closePopup(null);
          }
        }

        detailsNameInput.value = "";
        detailsPhoneInput.value = "";
        resetTryOnPhoneCodeSelect(detailsPhoneCodeSelect);
        if (detailsConsentInput) {
          detailsConsentInput.checked = false;
        }
        if (otpInput) {
          otpInput.value = "";
        }
        setInputErrorState(detailsNameInput, false);
        setInputErrorState(detailsPhoneInput, false);
        if (detailsPhoneCodeSelect) {
          setInputErrorState(detailsPhoneCodeSelect, false);
        }
        setDetailsError("");
        currentStep = "details";
        pendingPayload = null;
        pendingOtpPhone = "";
        setDetailsFormStep("details");
        setDetailsSubmitBusy(false);
        var headline = "Verify your phone for another try-on";
        if (detailsTitleEl) {
          detailsTitleEl.textContent = headline;
        }
        if (detailsInnerDialog) {
          detailsInnerDialog.setAttribute("aria-label", headline);
        }
        if (otpHintNode) {
          otpHintNode.textContent = "Enter the 6-digit code sent to your phone on WhatsApp.";
        }
        detailsModal.hidden = false;
        modal.classList.add("br-tryon-modal--details-open");
        detailsModal.addEventListener("click", overlayHandler);
        detailsSubmitButton.addEventListener("click", submitHandler);
        detailsCancelButton.addEventListener("click", cancelHandler);
        if (otpResendButton) {
          otpResendButton.addEventListener("click", resendHandler);
        }
        if (otpChangeButton) {
          otpChangeButton.addEventListener("click", changeNumberHandler);
        }
        setStatus("Enter your details and verify with OTP.");
        detailsNameInput.focus();
      });
    }

    async function handleDownload() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }
      setToolbarActionLoading(true, "Downloading…");
      setStatus("");
      try {
        await nextPaint();
        downloadBlob(generatedBlob, generatedFilename);
        setStatus("Downloaded.");
      } catch (err) {
        setStatus("Download failed.", "error");
        console.error("[TryOn] Download error:", err);
      } finally {
        setToolbarActionLoading(false);
      }
    }

    function buildWhatsAppSupportUrl() {
      var phone = String(modal.dataset.tryonWhatsappPhone || "").replace(/\D/g, "");
      if (!phone) {
        var legacyUrl = String(modal.dataset.tryonWhatsappUrl || "").trim();
        var phoneMatch = legacyUrl.match(/phone=(\d+)/);
        if (phoneMatch) {
          phone = phoneMatch[1];
        }
      }
      if (!phone) {
        return "";
      }
      var productTitle = String(modal.dataset.tryonProductTitle || "").trim() || "this product";
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var message =
        "Hi Team,\n\n" +
        "I need assistance regarding the " +
        productTitle +
        " available on your website:\n\n" +
        productUrl +
        "\n\n" +
        "Could you please provide details about its availability, customization options, delivery timeline, and sizing assistance? I would also appreciate any additional information that may help me place an order.\n\n" +
        "Thank you, and I look forward to your response.";
      return (
        "https://api.whatsapp.com/send/?phone=" +
        encodeURIComponent(phone) +
        "&text=" +
        encodeURIComponent(message)
      );
    }

    function handleWhatsApp() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      var url = buildWhatsAppSupportUrl();
      if (!url) {
        setStatus("WhatsApp link is not configured.");
        return;
      }
      window.open(url, "_blank", "noopener,noreferrer");
    }

    async function handleShare() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }

      var shareFile = new File([generatedBlob], generatedFilename, { type: "image/jpeg" });
      var shareText = "Try-On Result";
      if (navigator.canShare && navigator.canShare({ files: [shareFile] })) {
        setToolbarActionLoading(true, "Sharing…");
        setStatus("");
        try {
          await navigator.share({
            title: "Try-On Result",
            text: shareText,
            files: [shareFile]
          });
          setStatus("Shared successfully.");
        } catch (error) {
          setStatus("Share cancelled.");
        } finally {
          setToolbarActionLoading(false);
        }
      } else {
        setToolbarActionLoading(true, "Downloading…");
        setStatus("");
        try {
          await nextPaint();
          downloadBlob(generatedBlob, generatedFilename);
          setStatus("Share unsupported. Downloaded instead.");
        } catch (err) {
          setStatus("Download failed.", "error");
          console.error("[TryOn] Download error:", err);
        } finally {
          setToolbarActionLoading(false);
        }
      }
    }

    function getDailyGenerationLimit() {
      var raw = parseInt(modal.dataset.tryonDailyGenerationLimit, 10);
      return !isNaN(raw) && raw > 0 ? raw : 5;
    }

    function hasReachedDailyGenerationLimit(state) {
      state = state || readDailyState();
      return (state.generationAttempts || 0) >= getDailyGenerationLimit();
    }

    function updateGenerationLimitUi() {
      var atLimit = hasReachedDailyGenerationLimit();
      if (regenerateButton) {
        regenerateButton.disabled = atLimit;
        if (atLimit) {
          regenerateButton.setAttribute(
            "title",
            "Daily try-on limit reached (" + getDailyGenerationLimit() + "). Try again tomorrow."
          );
        } else {
          regenerateButton.removeAttribute("title");
        }
      }
    }

    /**
     * Popup on 2nd generation attempt only (regenerate / new photo after 1st result).
     * Download, share, and WhatsApp never trigger the popup.
     */
    async function ensureContactForTryOn(statusMessage) {
      var state = readDailyState();
      if (state.contactSubmitted) {
        return true;
      }
      if ((state.generationAttempts || 0) < 1) {
        return true;
      }
      var details = await askCustomerDetails("generate");
      if (!details) {
        setStatus("Contact details are required for another try-on.");
        return false;
      }
      setStatus(statusMessage || "Generating try-on result...");
      return true;
    }

    async function requestGeneration(fileBlob, options) {
      options = options || {};
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      var stateBefore = readDailyState();
      if (hasReachedDailyGenerationLimit(stateBefore)) {
        setStatus(
          "You can try on up to " +
            getDailyGenerationLimit() +
            " times per day. Please try again tomorrow.",
          "error"
        );
        updateGenerationLimitUi();
        return;
      }
      var wasContactSubmittedBefore = stateBefore.contactSubmitted === true;
      var contactOk = await ensureContactForTryOn(options.statusMessage);
      if (!contactOk) {
        return;
      }
      recordGenerationAttempt();
      if (wasContactSubmittedBefore) {
        submitStoredContactForCurrentProduct();
      }
      await sendToApi(fileBlob);
    }

    async function sendToApi(fileBlob) {
      var endpoint = modal.dataset.apiEndpoint;
      var apiKey = modal.dataset.apiKey || modal.dataset.apiAuth;
      if (!endpoint) {
        setStatus("API endpoint missing.");
        return;
      }
      if (!apiKey) {
        setStatus("API key missing.");
        return;
      }

      var garmentUrl = syncGarmentImage();
      if (!garmentUrl) {
        setStatus("Garment image missing.");
        return;
      }

      setStatus("Preparing images...");
      setLoading(true);
      var personEncoded;
      var garmentEncoded;
      try {
        personEncoded = await blobToJpegBase64(fileBlob);
        garmentEncoded = await imageUrlToJpegBase64(garmentUrl);
      } catch (prepErr) {
        setLoading(false);
        setStatus(
          (prepErr && prepErr.message) || "Could not prepare images for try-on.",
          "error"
        );
        console.error("[TryOn] Image prep error:", prepErr);
        return;
      }

      if (!personEncoded.base64 || !garmentEncoded.base64) {
        setLoading(false);
        setStatus("Could not prepare model or garment image.", "error");
        return;
      }

      var resolution = String(modal.dataset.tryonResolution || "1K").trim().toUpperCase();
      if (resolution !== "1K" && resolution !== "2K" && resolution !== "4K") {
        resolution = "1K";
      }

      var payload = {
        personImage: personEncoded.base64,
        garmentMimeType: garmentEncoded.mimeType || "image/jpeg",
        garmentImage: garmentEncoded.base64,
        resolution: resolution
      };

      setStatus("Generating try-on result...");
      var abortController = new AbortController();
      var abortTimer = setTimeout(function () { abortController.abort(); }, 600000);
      try {
        var response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": apiKey
          },
          body: JSON.stringify(payload),
          signal: abortController.signal
        });
        clearTimeout(abortTimer);

        var errBodyText = "";
        if (!response.ok) {
          try {
            errBodyText = await response.text();
          } catch (readErr) {
            console.warn("[TryOn] Could not read API error body:", readErr);
          }
          var errJson = null;
          if (errBodyText) {
            try {
              errJson = JSON.parse(errBodyText);
            } catch (parseErr) {
              /* use raw body text below */
            }
          }
          var errMsg = extractTryonApiErrorMessage(errJson, errBodyText, response.status);
          console.warn("[TryOn] API HTTP error:", response.status, errMsg, errBodyText || errJson);
          throw new Error(errMsg);
        }

        var apiResultBlob = await parseTryonSuccessResponse(response);
        if (!apiResultBlob) {
          throw new Error("No result image in API response.");
        }
        var finalBlob = await applyWatermark(apiResultBlob);
        generatedBlob = finalBlob;
        generatedFilename = "try-on-" + Date.now() + ".jpg";
        resultImage.src = URL.createObjectURL(finalBlob);
        setUploadState("result");
        setStatus("Try-on ready.");
        incrementSuccessfulGenerationCount();
        updateGenerationLimitUi();
      } catch (error) {
        clearTimeout(abortTimer);
        var msg =
          error && error.name === "AbortError"
            ? "Request timed out after 10 minutes. Please retry."
            : (error && error.message && String(error.message).trim()) ||
              "Try-on failed. Please retry.";
        setStatus(msg, "error");
        console.error("[TryOn] Try-on error:", msg, error);
      } finally {
        setLoading(false);
      }
    }

    function waitForVideoFrameReady(v, maxMs) {
      maxMs = maxMs || 500;
      if (v.videoWidth >= 2 && v.videoHeight >= 2 && v.readyState >= 2) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var finished = false;
        function done() {
          if (finished) {
            return;
          }
          finished = true;
          v.removeEventListener("loadeddata", onReady);
          v.removeEventListener("canplay", onReady);
          v.removeEventListener("resize", onReady);
          clearTimeout(tid);
          resolve();
        }
        function onReady() {
          if (v.videoWidth >= 2 && v.videoHeight >= 2) {
            done();
          }
        }
        v.addEventListener("loadeddata", onReady);
        v.addEventListener("canplay", onReady);
        v.addEventListener("resize", onReady);
        var tid = setTimeout(done, maxMs);
      });
    }

    function waitNextVideoFrame(el) {
      return new Promise(function (resolve) {
        if (!el) {
          resolve();
          return;
        }
        if (typeof el.requestVideoFrameCallback === "function") {
          el.requestVideoFrameCallback(function () {
            resolve();
          });
        } else {
          requestAnimationFrame(function () {
            resolve();
          });
        }
      });
    }

    async function ensureVideoPlaying(v) {
      if (!v) {
        return;
      }
      try {
        if (v.paused) {
          await v.play();
        }
      } catch (playErr) {
        /* stream already playing in most cases */
      }
    }

    async function captureFromCamera() {
      if (!video || !canvas) {
        return;
      }

      if (!isCaptureAllowed()) {
        setStatus(getCaptureBlockedReason() || "No person detected. Please try again.", "error");
        setCameraInstruction("Stand in middle for accurate outputs.");
        return;
      }

      await ensureVideoPlaying(video);

      var maxAttempts = cameraFacingMode === "environment" ? 5 : 3;
      var width = 0;
      var height = 0;
      var a = 0;
      for (a = 0; a < maxAttempts; a++) {
        try {
          await waitForVideoFrameReady(video, 1000);
        } catch (waitErr) {
          /* continue */
        }
        await ensureVideoPlaying(video);
        await waitNextVideoFrame(video);
        await waitNextVideoFrame(video);
        width = video.videoWidth || 0;
        height = video.videoHeight || 0;
        if (width >= 2 && height >= 2) {
          break;
        }
        await new Promise(function (r) {
          setTimeout(r, 180 + a * 120);
        });
      }

      if (width < 2 || height < 2) {
        setStatus("Could not read camera frame. Tap Camera to retry or use Choose Photo.");
        return;
      }
      var crop = getCaptureCrop(width, height);
      var targetSize = getTargetCaptureSize();
      canvas.width = targetSize.width;
      canvas.height = targetSize.height;
      var context = canvas.getContext("2d");
      context.drawImage(video, crop.sx, crop.sy, crop.sw, crop.sh, 0, 0, targetSize.width, targetSize.height);

      var humanConfirmed = await withTimeout(
        confirmHumanInCapture(canvas),
        CAPTURE_CONFIRM_TIMEOUT_MS + 200,
        false
      );
      if (!humanConfirmed) {
        bodySeenStreak = 0;
        lastHumanDetected = false;
        lastLiveFaceDetected = false;
        lastLiveFaceDetectedAt = 0;
        setStatus("No person detected. Please try again.", "error");
        setCameraInstruction("Stand in middle for accurate outputs.");
        return;
      }

      var blob = await new Promise(function (resolve) {
        canvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
      });

      if (!blob) {
        setStatus("Could not capture image.");
        return;
      }

      stopCamera();
      lastSourceBlob = blob;
      previewImage.src = URL.createObjectURL(blob);
      setUploadState("preview");
      setStatus("Captured. Sending to try-on...");
      requestGeneration(blob);
    }

    async function startCameraAndAutoCapture() {
      stopCamera();
      cameraFacingMode = "user";
      syncGarmentImage();
      setStatus("Requesting camera permission...");

      try {
        await ensurePoseReady();
        await attachLiveCameraStream();
        syncPoseConfidenceForFacing();
        setUploadState("camera");
        setStatus("Stand in middle for accurate outputs.");
        setCameraInstruction("Stand in middle for accurate outputs.");
        poseLoopActive = true;
        runPoseLoop();
        startBodyMonitor();
      } catch (error) {
        setStatus("Camera permission denied or unavailable.");
      }
    }

    function resetCameraCountdownState() {
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      setCountdownValue("");
      bodySeenStreak = 0;
      bodyLostStreak = 0;
    }

    async function flipCameraFacing(event) {
      if (event) {
        event.stopPropagation();
      }
      if (currentState !== "camera" || isLoading || !poseLoopActive || !video) {
        return;
      }
      var previousMode = cameraFacingMode;
      cameraFacingMode = previousMode === "user" ? "environment" : "user";
      setStatus("Switching camera…");
      try {
        if (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          stream = null;
        }
        await attachLiveCameraStream();
        syncPoseConfidenceForFacing();
        resetCameraCountdownState();
        latestPoseLandmarks = null;
        poseMissStreak = 0;
        lastHumanDetected = false;
        lastLiveFaceDetected = false;
        lastLiveFaceDetectedAt = 0;
        humanCheckInFlight = false;
        setStatus("Stand in middle for accurate outputs.");
        setCameraInstruction("Stand in middle for accurate outputs.");
      } catch (err) {
        cameraFacingMode = previousMode;
        try {
          await attachLiveCameraStream();
          syncPoseConfidenceForFacing();
          resetCameraCountdownState();
          latestPoseLandmarks = null;
          poseMissStreak = 0;
          lastHumanDetected = false;
          lastLiveFaceDetected = false;
          lastLiveFaceDetectedAt = 0;
          humanCheckInFlight = false;
          setStatus("Stand in middle for accurate outputs.");
          setCameraInstruction("Stand in middle for accurate outputs.");
        } catch (err2) {
          setStatus("Could not switch camera. Try again.", "error");
          console.warn("[TryOn] Flip camera failed:", err, err2);
        }
      }
    }

    function openModal() {
      syncGarmentImage();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("overflow-hidden");
      if (!contextMenuBlocker) {
        contextMenuBlocker = function (event) {
          if (modal.classList.contains("is-open")) {
            event.preventDefault();
          }
        };
      }
      document.addEventListener("contextmenu", contextMenuBlocker);
      setUploadState("empty");
      setLoading(false);
      setToolbarActionLoading(false);
      updateGenerationLimitUi();
      cameraFacingMode = "user";
      setStatus("Choose camera or upload to start try-on.");
      previewImage.src = "";
      resultImage.src = "";
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.classList.remove("br-tryon-modal--details-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("overflow-hidden");
      if (contextMenuBlocker) {
        document.removeEventListener("contextmenu", contextMenuBlocker);
      }
      if (detailsModal) {
        detailsModal.hidden = true;
      }
      setToolbarActionLoading(false);
      stopCamera();
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    cameraButton.addEventListener("click", startCameraAndAutoCapture);
    function handleManualCapture(event) {
      if (event) {
        event.stopPropagation();
      }
      if (currentState !== "camera" || isCameraCaptureInProgress || isLoading) {
        return;
      }
      if (!isCaptureAllowed()) {
        setStatus(getCaptureBlockedReason() || "No person detected. Please try again.", "error");
        setCameraInstruction("Stand in middle for accurate outputs.");
        return;
      }
      isCameraCaptureInProgress = true;
      captureFromCamera().finally(function () {
        isCameraCaptureInProgress = false;
      });
    }

    if (captureButton) {
      captureButton.addEventListener("click", handleManualCapture);
    }
    chooseButton.addEventListener("click", function () {
      fileInput.click();
    });

    uploadBox.addEventListener("click", function (event) {
      if (event.target && event.target.closest(".br-tryon-toolbar-stack")) {
        return;
      }
      if (event.target && event.target.closest(".br-tryon-camera-flip-row")) {
        return;
      }
      if (detailsModal && !detailsModal.hidden) {
        return;
      }
      if (currentState !== "camera") {
        fileInput.click();
      }
    });

    fileInput.addEventListener("change", function (event) {
      var file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      stopCamera();
      var objectUrl = URL.createObjectURL(file);
      previewImage.src = objectUrl;
      setUploadState("preview");
      setStatus("Checking photo...");

      var img = new Image();
      img.onload = function () {
        Promise.resolve()
          .then(function () {
            return ensurePoseReady().catch(function () {
              /* Face-only fallback if Pose fails to load */
            });
          })
          .then(function () {
            return ensureFaceDetectorReady();
          })
          .then(function () {
            return validatePersonStillImage(img);
          })
          .then(function (result) {
            if (!result || !result.ok) {
              URL.revokeObjectURL(objectUrl);
              previewImage.src = "";
              lastSourceBlob = null;
              setUploadState("empty");
              setStatus(
                (result && result.message) ||
                  "No person detected. Please use a clear photo of yourself.",
                "error"
              );
              fileInput.value = "";
              return;
            }
            lastSourceBlob = file;
            setStatus("Uploading selected photo...");
            requestGeneration(file);
          })
          .catch(function () {
            URL.revokeObjectURL(objectUrl);
            previewImage.src = "";
            lastSourceBlob = null;
            setUploadState("empty");
            setStatus("Could not validate photo. Please try another image.", "error");
            fileInput.value = "";
          });
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        previewImage.src = "";
        lastSourceBlob = null;
        setUploadState("empty");
        setStatus("Could not read that image. Please try another file.", "error");
        fileInput.value = "";
      };
      img.src = objectUrl;
    });

    regenerateButton.addEventListener("click", function () {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!lastSourceBlob) {
        setStatus("Capture or upload first, then regenerate.");
        return;
      }
      requestGeneration(lastSourceBlob, { statusMessage: "Regenerating..." });
    });

        [shareButton, downloadButton, whatsappButton, regenerateButton, cameraFlipButton, captureButton].forEach(function (button) {
      if (!button) {
        return;
      }
      button.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });

    if (cameraFlipButton) {
      cameraFlipButton.addEventListener("click", flipCameraFacing);
    }

    downloadButton.addEventListener("click", handleDownload);
    shareButton.addEventListener("click", handleShare);
    if (whatsappButton) {
      whatsappButton.addEventListener("click", handleWhatsApp);
    }

    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("variant:change", function () {
      syncGarmentImage();
    });

  }

  function boot() {
    document.querySelectorAll("[data-tryon-root]").forEach(initTryOn);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
